export default __webpack_public_path__ + "static/media/virgo.b6c325e2.png";